var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            { attrs: { layout: "inline", form: _vm.queryForm } },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "开始时间" } },
                        [
                          _c("a-date-picker", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["startTime"],
                                expression: "['startTime']"
                              }
                            ],
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请选择开始时间",
                              format: _vm.dateFormat,
                              disabledDate: _vm.disabledStartDate
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "结束时间" } },
                        [
                          _c("a-date-picker", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["endTime"],
                                expression: "['endTime']"
                              }
                            ],
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请选择结束时间",
                              format: _vm.dateFormat,
                              disabledDate: _vm.disabledEndDate
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { md: 8, sm: 24 } }, [
                    _c(
                      "span",
                      { staticClass: "table-page-search-submitButtons" },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.searchQuery }
                          },
                          [_vm._v(_vm._s(_vm.language["common.searchButton"]))]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "primary", icon: "reload" },
                            on: { click: _vm.searchReset }
                          },
                          [_vm._v(_vm._s(_vm.language["common.resetButton"]))]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-operator" },
        [
          _c(
            "a-button",
            {
              staticStyle: { "margin-left": "8px" },
              attrs: { type: "primary", icon: "download" },
              on: {
                click: function($event) {
                  return _vm.handleExport("用戶登錄統計")
                }
              }
            },
            [_vm._v(_vm._s(_vm.language["common.exportButton"]))]
          )
        ],
        1
      ),
      _vm.statisticsData || _vm.loading
        ? _c("div", { staticClass: "custom-header-wrapper" }, [
            _c(
              "div",
              { ref: "fixedHeader", staticClass: "fixed-header-container" },
              [
                _vm.fixedHeaderHtml
                  ? _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.fixedHeaderHtml) }
                    })
                  : _vm._e()
              ]
            ),
            _c(
              "div",
              {
                ref: "scrollHeaderContainer",
                staticClass: "scroll-header-container"
              },
              [
                _c(
                  "div",
                  { ref: "scrollHeaderContent", staticClass: "header-content" },
                  [
                    _vm.scrollHeaderHtml
                      ? _c("div", {
                          domProps: { innerHTML: _vm._s(_vm.scrollHeaderHtml) }
                        })
                      : _vm._e()
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm.statisticsData || _vm.loading
        ? _c("a-table", {
            ref: "table",
            staticClass: "custom-table login-statistics-factory-table",
            attrs: {
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: false,
              scroll: { x: _vm.scrollX },
              bordered: "",
              size: "middle",
              showHeader: false,
              loading: _vm.loading
            },
            on: { scroll: _vm.handleTableScroll },
            scopedSlots: _vm._u(
              [
                {
                  key: "groupName",
                  fn: function(text) {
                    return _c("span", {}, [
                      _c("strong", [_vm._v(_vm._s(text))])
                    ])
                  }
                },
                {
                  key: "factoryName",
                  fn: function(text) {
                    return _c("span", {}, [
                      _c("strong", [_vm._v(_vm._s(text))])
                    ])
                  }
                },
                {
                  key: "historyLoginCount",
                  fn: function(text) {
                    return _c("span", {}, [
                      _c("strong", [_vm._v(_vm._s(text))])
                    ])
                  }
                },
                {
                  key: "loginCount",
                  fn: function(text) {
                    return _c("span", {}, [
                      _c("strong", [_vm._v(_vm._s(text))])
                    ])
                  }
                },
                {
                  key: "total",
                  fn: function(text) {
                    return _c("span", {}, [
                      _c("strong", [_vm._v(_vm._s(text))])
                    ])
                  }
                }
              ],
              null,
              false,
              3131062468
            )
          })
        : _vm._e(),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.detailModalTitle,
            visible: _vm.detailModalVisible,
            width: 1200,
            footer: null,
            wrapClassName: "detail-modal-wrapper"
          },
          on: {
            cancel: function($event) {
              _vm.detailModalVisible = false
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "a-button",
                {
                  attrs: { type: "primary", icon: "download" },
                  on: { click: _vm.exportDetailData }
                },
                [_vm._v(_vm._s(_vm.language["common.exportButton"]))]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "detail-table-wrapper" },
            [
              _c("a-table", {
                attrs: {
                  columns: _vm.detailColumns,
                  "data-source": _vm.detailDataSource,
                  loading: _vm.detailLoading,
                  pagination: _vm.detailPagination,
                  size: "middle",
                  bordered: "",
                  scroll: { x: true, y: 800 }
                },
                on: { change: _vm.handleDetailTableChange },
                scopedSlots: _vm._u([
                  {
                    key: "sex",
                    fn: function(text) {
                      return _c("span", {}, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formatSex(text)) +
                            "\n          "
                        )
                      ])
                    }
                  },
                  {
                    key: "status",
                    fn: function(text) {
                      return _c("span", {}, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.formatStatus(text)) +
                            "\n          "
                        )
                      ])
                    }
                  }
                ])
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }